module.exports = __webpack_public_path__ + "img/label.c149ab3d.svg";